export type AuthPermission =
  | 'livinglab:read:decrypted-foreign-hashes'
  | 'livinglab:read:enrichment-data'
  | 'livinglab:write:enrichment-data'
  | 'livinglab:read:sample-tracking'
  | 'livinglab:write:sample-tracking'
  | 'superduperfiesta:user'
  | 'superduperfiesta:admin'
  | 'sample-tracking:admin'
  | 'livinglab:admin'
  | 'livinglab:user';

export const ALL_PERMISSIONS = {
  ADMIN: 'livinglab:admin' as AuthPermission,
  LL_USER: 'livinglab:user' as AuthPermission,
  DECRYPT_FOREIGN_HASHES: 'livinglab:read:decrypted-foreign-hashes' as AuthPermission,
  GREEN_SIDE_VIEW: 'livinglab:read:enrichment-data' as AuthPermission,
  GREEN_SIDE_WRITE: 'livinglab:write:enrichment-data' as AuthPermission,
  SAMPLE_TRACKING_VIEW: 'livinglab:read:sample-tracking' as AuthPermission,
  SAMPLE_TRACKING_WRITE: 'livinglab:write:sample-tracking' as AuthPermission,
  SDF_USER: 'superduperfiesta:user' as AuthPermission,
  SDF_ADMIN: 'superduperfiesta:admin' as AuthPermission,
  SAMPLE_TRACKING_ADMIN: 'sample-tracking:admin' as AuthPermission,
} as const;
